import { getItem, removeItem, setItem } from '@ms/yammer-libs-local-storage';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PersistStorage } from 'zustand/middleware';

interface LeftNavCollapseState {
  readonly isCollapsed: boolean;
}

const leftNavCollapseStorageKey = 'engage-left-nav-collapsed';

const leftNavCollapseStorage: PersistStorage<LeftNavCollapseState> = {
  getItem,
  setItem,
  removeItem,
};

const useLeftNavCollapseStore = create<LeftNavCollapseState>()(
  persist((): LeftNavCollapseState => ({ isCollapsed: false }), {
    name: leftNavCollapseStorageKey,
    storage: leftNavCollapseStorage,
  })
);

export const useIsLeftNavCollapsed = (): boolean => useLeftNavCollapseStore((state) => state.isCollapsed);

export const setLeftNavCollapsed = (isCollapsed: boolean): void => {
  useLeftNavCollapseStore.setState({ isCollapsed });
};

export const toggleLeftNavCollapsed = (): void => {
  useLeftNavCollapseStore.setState((state) => ({ isCollapsed: !state.isCollapsed }));
};
